import { EventEmitTypes, events, SimulateEventTypes } from './eventEmiter';
function registerOrientationChange() {
    events.on(EventEmitTypes.ORIENTATION_CHANGE, function (e) {
        var angle = e.rotate ? 90 : 0;
        var type = e.rotate ? 'landscape-primary' : 'portrait-primary';
        Object.defineProperty(window.__iframeWindow.screen.orientation, 'angle', {
            value: angle,
            configurable: true,
        });
        Object.defineProperty(window.__iframeWindow.screen.orientation, 'type', {
            value: type,
            configurable: true,
        });
        window.__iframeWindow.dispatchEvent(new Event(SimulateEventTypes.ORIENTATION_CHANGE));
    });
}
// editor中通过EventEmitter派发事件，统一在这里注册 & 派发模拟器中iframe中的模拟事件
export function registerSimulateEvent() {
    registerOrientationChange();
}
//# sourceMappingURL=simulateEventRegister.js.map